export default "__VITE_ASSET__BmJJM1uB__"